import { createContext, useContext } from 'react'
import { ResizeHandle } from './types'

const noop = () => {}

interface DispositionInteractionContextValue {
  getDraftStart: (techId: string) => (iso: string) => void
  getDraftMove: (techId: string) => (iso: string) => void
  getDraftCommit: (techId: string, name: string | null) => () => void
  getDraftCancel: () => void
  onResizeStart: (handle: ResizeHandle) => void
  onResizeMove: (minutesDelta: number) => void
  onResizeEnd: () => void
  onBlockMove: (newAnfahrtStartIso: string) => void
  onBlockMoveEnd: () => void
  onBlockMoveToRow: (techId: string) => void
}

const DispositionInteractionContext = createContext<DispositionInteractionContextValue>({
  getDraftStart: () => noop,
  getDraftMove: () => noop,
  getDraftCommit: () => () => noop,
  getDraftCancel: noop,
  onResizeStart: noop,
  onResizeMove: noop,
  onResizeEnd: noop,
  onBlockMove: noop,
  onBlockMoveEnd: noop,
  onBlockMoveToRow: noop,
})

export const DispositionInteractionProvider = DispositionInteractionContext.Provider

export function useDispositionInteraction(): DispositionInteractionContextValue {
  return useContext(DispositionInteractionContext)
}
